import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSizeEnum } from '../../enum/modal-size.enum';
import { ReportTypeSelectModalComponent } from '../report-type-select-modal/report-type-select-modal.component';

@Component({
  selector: 'app-report-type-select',
  templateUrl: './report-type-select.component.html',
  styleUrls: ['./report-type-select.component.css']
})
export class ReportTypeSelectComponent implements OnInit {

  @Input() translatekey: string;
  @Input() values: String[];
  @Input() selected: string;
  @Input() title: string;

  @Output() valueChange = new EventEmitter();
  constructor(
    private modalService: NgbModal,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }
  openModal() {
    const modalRef = this.modalService.open(ReportTypeSelectModalComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE,
    });
    //
    //modal  veri geçişi
    modalRef.componentInstance.selected = this.selected;
    modalRef.componentInstance.translatekey = this.translatekey;
    modalRef.componentInstance.values = this.values;

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      // Cevap boş değilse
      if (receivedEntry) {
        //
        this.selected = receivedEntry;
        this.valueChange.emit(this.selected);
      }

      // modal kapat
      modalRef.close();
    });

  }
}
